/*
 * SIJL - het samengestelde doosje in de winkelwagen.
 *
 * Bij het toevoegen aan de winkelwagen sturen we een verborgen eigenschap mee
 * met de bestandsnamen van de gekozen bonbons, in doosvolgorde (zie
 * sections/sijl-bonbon-buy-box.liquid en assets/sijl-combo.js). De mail en de
 * pakbon tekenen daar het doosje mee. Dit bestand doet hetzelfde in de
 * winkelwagen.
 *
 * Waarom via JavaScript en niet in het thema-sjabloon: de eigenschap begint met
 * een underscore en Horizon slaat die bij het tekenen bewust over. Dat willen we
 * ook zo houden - de klant hoeft geen rijtje bestandsnamen te zien. We halen de
 * gegevens daarom uit /cart.js en hangen het doosje er zelf onder.
 *
 * We doen er nog iets bij: de regels "Rij 1", "Rij 2", ... verdwijnen zodra het
 * doosje er staat, en de smaken komen als een enkele zin onder het plaatje. In
 * de winkelwagen is die rijindeling namelijk al te zien - hem er ook nog eens
 * in woorden bij zetten maakt van een bestelregel een muur tekst. Op de pakbon
 * en in de bevestigingsmail blijven de rijen staan; daar wordt het doosje
 * daadwerkelijk rij voor rij ingelegd.
 *
 * De opmaak staat hieronder in plaats van in sijl-custom.css. Dat bestand is
 * inmiddels ruim 33 kB en gaat bij elke wijziging in zijn geheel opnieuw over de
 * lijn; een halve kilobyte voor een onderdeel dat alleen op de winkelwagen
 * bestaat is dat risico niet waard.
 *
 * Let op bij wijzigen: de waarnemer wordt losgekoppeld voordat we iets in de
 * pagina hangen en daarna weer aangezet. Doe je dat niet, dan ziet hij zijn
 * eigen wijziging en begint het opnieuw - tot de pagina vastloopt.
 */

(function () {
  'use strict';

  var RIJEN = { 10: [3, 4, 3], 15: [5, 5, 5], 24: [6, 6, 6, 6], 35: [7, 7, 7, 7, 7] };
  var BASIS = '/cdn/shop/files/';

  var waarnemer = null;
  var wachtend = null;
  var bezig = false;

  function stijl() {
    if (document.getElementById('sijl-wagen-stijl')) return;
    var s = document.createElement('style');
    s.id = 'sijl-wagen-stijl';
    /* Het bakje is wit met een zachte schaduw, net als het echte doosje: een
       wit binnenwerk in een oranje huls. De bonbonfoto's zijn 200 bij 148 -
       breder dan hoog - dus zetten we alleen de breedte vast en laten we de
       hoogte vrij, anders wordt de bonbon platgedrukt. Geen ronde uitsnede: de
       foto heeft zelf al de vorm van een bonbon op een doorzichtige
       achtergrond. De rijen staan gecentreerd, zodat de honingraat van 3-4-3
       ook echt als honingraat leest.

       De min-width op de foto's is geen franje. Een doosje van 35 is zeven
       bonbons breed en dat past op een telefoon niet naast elkaar; zonder die
       regel groeit de rij dwars door het bakje heen. Nu krimpen ze samen, en
       omdat de hoogte vrij is houdt de bonbon zijn verhouding. Bij de brede
       dozen halen we de marges wat aan, zodat die krimp minder ver hoeft te
       gaan en de bonbons niet in de ruimte komen te zweven. */
    s.textContent =
      '.sijl-wagen-doosje{margin:9px 0 2px}' +
      '.sijl-wagen-doosje__bak{display:inline-block;box-sizing:border-box;max-width:100%;' +
      'padding:9px 11px 8px;' +
      'border:1px solid rgb(0 0 0 / .08);border-radius:10px;background:#fff;' +
      'box-shadow:0 1px 4px rgb(0 0 0 / .07)}' +
      '.sijl-wagen-doosje__bak--breed{padding:7px 8px 6px}' +
      '.sijl-wagen-doosje__rij{display:flex;justify-content:center;gap:4px;line-height:0}' +
      '.sijl-wagen-doosje__bak--breed .sijl-wagen-doosje__rij{gap:2px}' +
      '.sijl-wagen-doosje__rij + .sijl-wagen-doosje__rij{margin-top:3px}' +
      '.sijl-wagen-doosje__bak--breed .sijl-wagen-doosje__rij + .sijl-wagen-doosje__rij{margin-top:2px}' +
      '.sijl-wagen-doosje img{display:block;width:26px;min-width:0;height:auto}' +
      '.sijl-wagen-doosje__smaken{margin:7px 0 0;font-size:12px;line-height:1.45;opacity:.7}';
    document.head.appendChild(s);
  }

  function indeling(aantal) {
    if (RIJEN[aantal]) return RIJEN[aantal];
    return [aantal];
  }

  function bouwBak(bestanden) {
    var vorm = indeling(bestanden.length);
    var breedste = Math.max.apply(null, vorm);

    var bak = document.createElement('div');
    bak.className = 'sijl-wagen-doosje__bak';
    if (breedste > 5) bak.className += ' sijl-wagen-doosje__bak--breed';
    bak.setAttribute('aria-hidden', 'true');

    var index = 0;
    vorm.forEach(function (aantal) {
      var rij = document.createElement('div');
      rij.className = 'sijl-wagen-doosje__rij';
      for (var k = 0; k < aantal; k++) {
        var naam = bestanden[index];
        index += 1;
        if (!naam) continue;
        var img = document.createElement('img');
        img.src = BASIS + naam + '?width=78';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 26;
        img.height = 19;
        rij.appendChild(img);
      }
      if (rij.children.length) bak.appendChild(rij);
    });

    return bak.children.length ? bak : null;
  }

  /* De smaken staan al op de pagina, verdeeld over de regels Rij 1, Rij 2, ...
     We halen ze daar vandaan in plaats van uit de bestandsnamen: dan staat er
     precies wat de klant zelf heeft uitgekozen, met hoofdletters en al.

     Dubbele smaken tellen we op in plaats van ze te herhalen. In een doosje van
     35 zit een smaak al gauw vier keer; die vijfendertig namen achter elkaar
     lopen over het halve scherm. "4x Koffie" zegt hetzelfde in een kwart van de
     ruimte. Een smaak die er maar een keer in zit krijgt geen getal - anders
     staat er bij een doosje van tien tien keer een overbodige "1x". */
  function smakenUit(regel) {
    var volgorde = [];
    var aantallen = {};
    var gevonden = [];
    var eigenschappen = regel.querySelectorAll('.cart-items__property');

    for (var i = 0; i < eigenschappen.length; i++) {
      var dt = eigenschappen[i].querySelector('dt');
      var dd = eigenschappen[i].querySelector('dd');
      if (!dt || !dd) continue;
      if (!/^rij\s*\d+\s*:?$/i.test(dt.textContent.trim())) continue;

      gevonden.push(eigenschappen[i]);
      dd.textContent.split('|').forEach(function (naam) {
        var schoon = naam.trim();
        if (!schoon) return;
        if (!aantallen[schoon]) {
          aantallen[schoon] = 0;
          volgorde.push(schoon);
        }
        aantallen[schoon] += 1;
      });
    }

    var namen = volgorde.map(function (naam) {
      return aantallen[naam] > 1 ? aantallen[naam] + 'x ' + naam : naam;
    });

    return { namen: namen, regels: gevonden };
  }

  function regels() {
    return document.querySelectorAll('.cart-items__table-row[data-key]');
  }

  async function teken() {
    if (bezig) return;
    var rijen = regels();
    if (!rijen.length) return;

    /* Staat het er al bij alle regels die het nodig hebben, dan hoeven we niets. */
    var nogTeDoen = false;
    for (var i = 0; i < rijen.length; i++) {
      if (!rijen[i].querySelector('.sijl-wagen-doosje')) nogTeDoen = true;
    }
    if (!nogTeDoen) return;

    bezig = true;
    try {
      var wagen = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (a) {
        return a.json();
      });

      var perSleutel = {};
      wagen.items.forEach(function (item) {
        var fotos = item.properties ? item.properties._fotos : null;
        if (fotos) perSleutel[item.key] = String(fotos).split(',');
      });

      if (waarnemer) waarnemer.disconnect();

      rijen = regels();
      for (var j = 0; j < rijen.length; j++) {
        var rij = rijen[j];
        if (rij.querySelector('.sijl-wagen-doosje')) continue;

        var bestanden = perSleutel[rij.dataset.key];
        if (!bestanden || !bestanden.length) continue;

        var plek = rij.querySelector('.cart-items__variants-wrapper') || rij.querySelector('.cart-items__details');
        if (!plek) continue;

        var bak = bouwBak(bestanden);
        if (!bak) continue;

        var doos = document.createElement('div');
        doos.className = 'sijl-wagen-doosje';
        doos.appendChild(bak);

        /* Pas als het plaatje er staat ruimen we de rijregels op, en nooit
           eerder: gaat er iets mis, dan houdt de klant gewoon zijn lijstje. */
        var smaken = smakenUit(rij);
        if (smaken.namen.length) {
          var zin = document.createElement('p');
          zin.className = 'sijl-wagen-doosje__smaken';
          zin.textContent = smaken.namen.join(' · ');
          doos.appendChild(zin);
          smaken.regels.forEach(function (r) {
            r.style.display = 'none';
          });
        }

        plek.appendChild(doos);
      }

      stijl();
    } catch (e) {
      /* Lukt het ophalen niet, dan blijft de winkelwagen gewoon zoals hij was. */
    } finally {
      bezig = false;
      kijkMee();
    }
  }

  function later() {
    window.clearTimeout(wachtend);
    wachtend = window.setTimeout(teken, 120);
  }

  function kijkMee() {
    var doel = document.querySelector('cart-items-component') || document.body;
    if (!doel) return;
    if (!waarnemer) waarnemer = new MutationObserver(later);
    waarnemer.observe(doel, { childList: true, subtree: true });
  }

  function start() {
    teken();
    kijkMee();
    document.addEventListener('cart:update', later);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
